var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { bip32asBuffer } from "./bip32";
import { MAX_SCRIPT_BLOCK } from "./constants";
export function provideOutputFullChangePath(transport, path) {
    var buffer = bip32asBuffer(path);
    return transport.send(0xe0, 0x4a, 0xff, 0x00, buffer);
}
export function hashOutputFull(transport, outputScript, additionals) {
    if (additionals === void 0) { additionals = []; }
    return __awaiter(this, void 0, void 0, function () {
        var offset, p1, isDecred, blockSize, p1_1, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    offset = 0;
                    p1 = Number(0x80);
                    isDecred = additionals.includes("decred");
                    ///WARNING: Decred works only with one call (without chunking)
                    //TODO: test without this for Decred
                    if (isDecred) {
                        return [2 /*return*/, transport.send(0xe0, 0x4a, p1, 0x00, outputScript)];
                    }
                    _a.label = 1;
                case 1:
                    if (!(offset < outputScript.length)) return [3 /*break*/, 3];
                    blockSize = offset + MAX_SCRIPT_BLOCK >= outputScript.length
                        ? outputScript.length - offset
                        : MAX_SCRIPT_BLOCK;
                    p1_1 = offset + blockSize === outputScript.length ? 0x80 : 0x00;
                    data = outputScript.slice(offset, offset + blockSize);
                    return [4 /*yield*/, transport.send(0xe0, 0x4a, p1_1, 0x00, data)];
                case 2:
                    _a.sent();
                    offset += blockSize;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=finalizeInput.js.map